import { config } from '../config.js';

// TODO:
// - move hardcoded ids to .env file
const msalConfiguration = {
    auth: {
        clientId: config.MSAL_CLIENT_ID,
        authority: config.MSAL_AUTHORITY,
        redirectUri: '/',
        postLogoutRedirectUri: config.REACT_APP_ENC_LANDING_APP_URL,
    },
    cache: {
        cacheLocation: 'localStorage',
        storeAuthStateInCookie: false,
    },
};
const loginRequest = {
    scopes: [
        config.MSAL_SCOPE,
    ],
};

export { loginRequest, msalConfiguration };
